import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  field: {
    flex: "0 100%",
    maxWidth: "calc(100vw - 32px)"
  },
  field40: {
    [theme.breakpoints.up("md")]: {
      flex: "0 calc(40% - 10px)"
    }
  },
  field60: {
    [theme.breakpoints.up("md")]: {
      flex: "0 calc(60% - 10px)"
    }
  },
  fieldMobile40: {
    [theme.breakpoints.down("sm")]: {
      flex: "0 calc(40% - 10px)"
    }
  },
  fieldMobile60: {
    [theme.breakpoints.down("sm")]: {
      flex: "0 calc(60% - 10px)"
    }
  },
  fieldSelectCheckboxChecked: {
    "&.Mui-checked": {
      color: theme.palette.secondary.dark
    },
    "&.Mui-checked.MuiCheckbox-indeterminate": {
      color: theme.palette.primary.dark
    }
  },
  fieldSelectRoot: {
    "& .MuiSelect-select.MuiSelect-select": {
      padding: "8px 12px",
      fontSize: 12
    }
  },
  fieldMultipleSelectRoot: {
    padding: "10px 12px",
    fontSize: 12,
    lineHeight: "normal",
    "& .MuiInputLabel-shrink": {
      transform: "none"
    }
  },
  fieldSelectSelect: {
    textTransform: "capitalize"
  },
  fieldSelectPlaceholder: {
    color: theme.palette.primary.light
  },
  textFieldInput: {
    padding: "0 16px",
    height: 36,
    fontSize: 12
  },
  selectFieldInput: {
    "&.Mui-disabled": {
      color: theme.palette.primary.dark,
      backgroundColor: "#eee",
      "& + .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.light
      }
    }
  },
  textFieldInputMultiline: {
    padding: "12px 0"
  },
  textFieldLabel: {
    fontSize: 14,
    color: theme.palette.primary.dark,
    position: "relative",
    transform: "none",
    transformOrigin: "none",
    paddingBottom: 8,
    whiteSpace: "nowrap",
    "&.MuiFormLabel-root.Mui-focused": {
      color: theme.palette.primary.dark
    }
  },
  optional: {
    color: theme.palette.text.hint
  },
  datePickerIcon: {
    width: 17
  },
  yesNoButtonWrapper: {
    display: "flex",
    gap: 15
  },
  yesNoButton: {
    padding: 0,
    height: 46,
    flexGrow: 1,
    flex: 1
  },
  yesNoButtonSelected: {
    "& $yesNoButtonStartIcon": {
      color: "#103827",
      backgroundColor: "#c0e8d8"
    },
    "& $yesNoButtonText": {
      color: "#103827",
      backgroundColor: "#eff9f5"
    }
  },
  yesNoButtonLabel: {
    display: "flex",
    justifyContent: "space-between"
  },
  yesNoButtonStartIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 46,
    height: 46,
    margin: 0,
    border: "1px solid rgba(186, 186, 186, 1)",
    borderRadius: "4px 0 0 4px",
    color: theme.palette.primary.light
  },
  yesNoButtonText: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 46,
    color: theme.palette.primary.light,
    border: "1px solid rgba(186, 186, 186, 1)",
    borderLeft: "none",
    borderRadius: "0 4px 4px 0"
  },
  uploadFieldButton: {
    marginRight: -2
  },
  uploadFieldIcon: {
    fontSize: 18
  },
  subOption: {
    paddingLeft: 32
  },
  optionText: {
    textTransform: "capitalize"
  },
  boolChoiceError: {
    fontSize: 11,
    color: theme.palette.error.main,
    height: 24,
    marginTop: 6
  },
  validationError: {
    borderColor: theme.palette.error.main
  },
  rightAligning: {
    textAlign: "end"
  },
  indeterminateIcon: {
    color: theme.palette.primary.dark
  }
}));
